<lf-general-dialog-layout class="fileset-modal">
    <span lf-widget class="dialog-header">{{ 'lf_fileset_select_import' | localize: lfFilesetLocalizeHelper }}</span>
    <button type="button" icon-button class="dialog-header" (click)="onClose()">
        <svg class="tool-bar-icon" title="close">
            <use xlink:href="#_svg-close"></use>
        </svg>
    </button>
    <div class="dialog-content">
        <div lf-label style="padding-bottom:5px">{{ 'lf_fileset_import_from' | localize: lfFilesetLocalizeHelper }}</div>
        <button type="button" class="import-type-option" (click)="onSelectImport(local)">{{ 'lf_fileset_local' | localize: lfFilesetLocalizeHelper }}</button>
        <button type="button" class="import-type-option" (click)="onSelectImport(repo)">{{ 'lf_fileset_repository' | localize: lfFilesetLocalizeHelper }}</button>
    </div>
</lf-general-dialog-layout>